import React from "react";
import { FaStar } from "react-icons/fa";
import "./Awards.css";
const Awards = () => {
  const awards = [
    {
      title: "Most Outstanding Chapter/Affinity Group",
      year: "2023/2024",
      description:
        "Awarded the Most Outstanding Chapter/Affinity Group for Term 2023/2024 by the IEEE Student Branch of the University of Moratuwa.",
      category: "Excellence",
      color: "#FFD700",
    },
  ];
  return (
    <section id="awards" className="awards">
      {" "}
      <div className="container">
        {" "}
        <h2 className="section-title">Awards & Recognition</h2>{" "}
        <div className="awards-grid">
          {" "}
          {awards.map((award, index) => (
            <div key={index} className="award-card">
              {" "}
              <img
                src="/assets/Award.png"
                alt="Award"
                className="award-image"
              />{" "}
              <div className="award-year">{award.year}</div>{" "}
              <div className="award-content">
                {" "}
                <div className="award-category">{award.category}</div>{" "}
                <h3 className="award-title">{award.title}</h3>{" "}
                <p className="award-description">{award.description}</p>{" "}
              </div>{" "}
              <div className="award-badge">
                {" "}
                <FaStar />{" "}
              </div>{" "}
            </div>
          ))}{" "}
        </div>{" "}
      </div>{" "}
    </section>
  );
};
export default Awards;
